export enum LATITUDE_LONGITUDE {
  LATITUDE,
  LONGITUDE,
}
